import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DadosPessoaisAba1Response } from 'app/auth/_models/DadosPessoaisAba1';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Observable } from "rxjs";
import { PlanoDeSaudeServidorDto } from "./plano-de-saude-servidor.dto";
import {
  PlanoDeSaudeServidorAba10Service
} from "../../service/plano-de-saude-servidor-aba10/plano-de-saude-servidor-aba10.service";
import { ConcessaoAuxDto } from "./concessaoAux.dto";
import { MatSelect, MatSelectChange } from "@angular/material/select";
import { AuxilioSaudeFormDto } from "./AuxilioSaudeForm.dto";
import { saveAs } from 'file-saver';
import { CampanhasService } from "../../service/campanhas/campanhas.service";

const ELEMENT_DATA: ConcessaoAuxDto[] = [];

@Component({
  selector: 'app-recadastramento-aba10',
  templateUrl: './recadastramento-aba10.component.html',
  styleUrls: ['./recadastramento-aba10.component.sass']
})
export class RecadastramentoAba10Component implements OnInit {

  @Input() dadosPessoaisUser: any;
  @Input() mostrarAlerta: any;
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();
  @Output() dadosSalvos: EventEmitter<void> = new EventEmitter<void>();
  @Output() formularioSalvo = new EventEmitter<void>();
  form: FormGroup;
  user: DadosPessoaisAba1Response = null;

  isLoading: boolean = true;
  isInfoImportantVisible: boolean = true;

  meslist: ConcessaoAuxDto[] = [];

  displayedColumns: string[] = ['meses', 'valorMensalidade', 'valorPago', 'acoes'];
  dataSource = ELEMENT_DATA;

  planosServidor: PlanoDeSaudeServidorDto[];
  concessoesServidor: ConcessaoAuxDto[];
  markTodos: boolean = false;

  isLoadingFile: boolean = false;
  arquivoSelecionado: File;
  existAnexo: boolean = true;
  flFile: boolean;
  concessaoAux: AuxilioSaudeFormDto = new AuxilioSaudeFormDto();
  existDiff: Boolean = false;
  private existeMesSelecionado: boolean = false;
  listTabela: ConcessaoAuxDto[] = [];
  temPlano: boolean = true
  flPendencias: boolean = false;
  tituloCampanhaRecadVigente: string;

  @ViewChild('fileInputTitulo') fileInputTituloElementRef: ElementRef;

  constructor(
    private toasterService: ToastrService,
    private formBuilder: FormBuilder,
    private planoDeSaudeService: PlanoDeSaudeServidorAba10Service,
    private campanhasService: CampanhasService
  ) {
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));
    this.form = this.formBuilder.group({
      codigoPlano: ['',],
      valor: ['', [Validators.required]],
      valorPago: ['', [Validators.required]],
      flTodos: ['', [Validators.required]],
      meses: ['', []],

    });
    this.form.controls['valorPago'].disable();
  }

  ngOnInit(): void {
    this.carregarDadosIniciais();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mostrarAlerta) {
      this.isInfoImportantVisible = true
    }
  }

  toggleInfoImportantVisible() {
    this.isInfoImportantVisible = !this.isInfoImportantVisible;
  }

  atualizarAuxilioSaude() {
    // if (this.form.valid) {
    // Lógica para enviar os dados do formulário
    //   this.dadosContatoAba8.atualizarDadosContato(this.form.value).subscribe(
    //     (response) => {
    //       this.toasterService.success('Dados atualizados com sucesso');
    //       this.dadosSalvos.emit();
    //       this.formularioSalvo.emit();
    //     },
    //     (error) => {
    //       console.error('Erro ao atualizar os dados', error);
    //     }
    //   );
    // } else {
    //   this.toasterService.warning('Atenção: Todos os campos marcados com (*) são obrigatórios!');
    // }
  }

  getObsevableConcessoes(codigo: string): Observable<ConcessaoAuxDto[]> {
    return this.planoDeSaudeService.getConcessoes(codigo);
  }

  avancaParaProximoTab() {
    let planoAtual = this.form.value.codigoPlano;
    if (this.temPlano == true) {
      let existMesPendente: boolean = false
      let listConcessoes = [];
      this.planosServidor.forEach(p => {
        listConcessoes.push(this.getObsevableConcessoes(p.codigo.toString()));
      })

      forkJoin(listConcessoes).subscribe(resp => {
        resp.forEach( (r: ConcessaoAuxDto[]) => {
          this.atualizaEstadoMeses(r);
          if (this.meslist.length > 0 ) {
            existMesPendente = true;
          }
        })
        if (!existMesPendente) {
          this.toasterService.success('Dados atualizados com sucesso!', '', {
            timeOut: 2000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
          });
          this.dadosSalvos.emit()
        } else {
          this.planoDeSaudeService.getConcessoes(this.form.value.codigoPlano).subscribe( resp => {
            this.atualizaEstadoMeses(resp);
          });
          this.toasterService.error('Por favor, preencha os valores pagos de todos os meses.');
        }
      })
    } else {
      this.toasterService.success('Dados atualizados com sucesso!', '', {
        timeOut: 2000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });
      this.dadosSalvos.emit()
    }
  }

  private atualizaEstadoMeses(r: ConcessaoAuxDto[]) {
    this.concessoesServidor = r;
    this.meslist = [];
    this.dataSource = [];
    this.montarComboDatas();
  }

  voltarPaginaAnterior() {
    this.voltarPagina.emit()
  }


  carregarDadosIniciais() {
    this.planoDeSaudeService.getPlanos().subscribe(resp => {
      this.planosServidor = resp;
      if(this.planosServidor.length>0){
        this.form.get('codigoPlano').patchValue(this.planosServidor[0].codigo);
        this.checkDiffPlano();
      }
      if (this.planosServidor.length == 0) {
        this.temPlano = false
      }
    })
    this.campanhasService.getCampanhaRecadVigente().subscribe( resp => {
      this.tituloCampanhaRecadVigente = resp.nome;
    })
  }

  checkDiffPlano() {
    this.meslist.length > 0 ? this.flPendencias = true : this.flPendencias=false;
    this.getConcessoes(this.form.value.codigoPlano);
  }

  private getConcessoes(codigoPlano: string) {
    this.planoDeSaudeService.getConcessoes(codigoPlano).subscribe(resp => {
      this.meslist = [];
      this.dataSource = [];
      this.markTodos = false
      this.form.get('meses').patchValue([])
      this.concessoesServidor = resp;
      this.montarComboDatas();
    });
  }

  private montarComboDatas() {
    this.concessoesServidor.forEach(n => {
      if (n.valorPago == '0' || n.valorPago == '0,00' || n.valorPago == null) {
        !this.meslist.includes(n) ? this.meslist.push(n) : false;
        this.meslist.sort((a, b) => a.mes - b.mes);
      } else {
        this.dataSource.push(n);
      }
    })
  }

  refreshConcessoes(codigoPlano: number) {
    this.form.get('codigoPlano').patchValue(codigoPlano);
    this.getConcessoes(this.form.value.codigoPlano);
  }

  checkDiffMeses() {
    this.form.controls['valorPago'].enable();
    if (this.form.value.meses[0] == '0') {
      this.markTodos = true;
      let listdata: any[] = [];
      listdata.push(0);

      this.meslist.forEach((obj, index) => {
        listdata.push(obj.mes);
      });

      this.form.get('meses').patchValue(listdata);
    } else {
      this.form.value.meses.length < 1 ? this.form.controls['valorPago'].disable() : this.form.controls['valorPago'].enable();
      if (this.form.value.meses[0] != '0' && this.markTodos) {
        this.markTodos = false;
        this.form.controls['valorPago'].disable();
        this.form.get('meses').patchValue([]);

      }
    }
  }

  onArquivoSelecionado(event: any) {
    const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    const maxFileSizeInBytes = 1024 * 1024 * 10; // 10 MB
    const file = event.target.files[0];

    if (file && allowedFileTypes.includes(file.type) && file.size <= maxFileSizeInBytes) {
      this.isLoadingFile = true;
      this.arquivoSelecionado = file;
      this.existAnexo = true;
      this.enviarAnexo();
    }
    else {
      this.arquivoSelecionado = null;

      if (!allowedFileTypes.includes(file.type)) {
        this.toasterService.warning('Tipo de arquivo inválido! Apenas arquivos JPG, JPEG, PNG e PDF são permitidos.');
      } else if (file.size > maxFileSizeInBytes) {
        this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
      }
      this.onArquivoExcluido('arquivoInvalido')
    }
  }

  private enviarAnexo() {
    this.concessaoAux.valor = this.form.value.valorPago;
    this.form.value.meses[0] == '0' && this.form.value.meses.length == 13 ? this.concessaoAux.flTodos = true : this.concessaoAux.flTodos = false;
    !this.concessaoAux.flTodos ? this.concessaoAux.meses = this.form.value.meses : this.concessaoAux.meses = [];

    this.concessaoAux.meses[0] == 0 ? this.concessaoAux.meses.splice(0, 1) : false;

    this.concessaoAux.codigoPlano = this.form.value.codigoPlano;

    this.concessaoAux.meses.forEach((v, i) => {
      this.meslist.splice(v, 1);
    })

    if (this.arquivoSelecionado) {
      this.toasterService.info('Enviando arquivo. Por favor, aguarde.', '', {
        timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });

      this.planoDeSaudeService.uploadComprovante(this.arquivoSelecionado, this.concessaoAux).subscribe(
        (response) => {
          this.isLoadingFile = false;
          this.flFile = false;
          this.arquivoSelecionado = null;
          this.toasterService.success('Arquivo enviado', '', {
            timeOut: 1500, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
          });
          this.fileInputTituloElementRef.nativeElement.value = "";
          this.form.get('valorPago').reset()
          this.form.get('valorPago').disable();
          this.refreshConcessoes(this.concessaoAux.codigoPlano);
        },
        (error) => {
          this.fileInputTituloElementRef.nativeElement.value = "";
          if (error.status == 422) {

            this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.', '', {
              timeOut: 2000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
            });
          } else {

            this.toasterService.error(`Erro ao enviar o anexo: ${error.error.message}`, '', {
              timeOut: 2000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
            });
          }

          this.onArquivoExcluido('erro')

        }
      );
    }
  }

  private onArquivoExcluido(tipo) {
    this.flFile = false;
    this.arquivoSelecionado = null;
    this.isLoadingFile = false;
    const input = document.getElementById('input-file-titulo-eleitor') as HTMLInputElement;
    input.value = '';
    if (tipo == 'erro')  this.toasterService.success('Arquivo excluído com sucesso!', '', {
      timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
    });
  }

  extistDiff() {
    this.existDiff = true;
  }

  excluirItemTable(element) {
    let codigoPlano = this.form.value.codigoPlano;

    this.toasterService.info('Deletando registro!', '', {
      timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
    });



    // this.toasterService.info('Deletando registro.');
    this.planoDeSaudeService.deleteComprovante(codigoPlano, element.mes).subscribe(resp => {
      this.dataSource = this.dataSource.filter(
        row => element != row
      );
      !this.meslist.includes(element) ? this.meslist.push(element) : false;
      this.meslist.sort((a, b) => a.mes - b.mes);
      this.toasterService.success('Registro deletado.', '', {
        timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });
      // this.toasterService.success('Registro deletado.');
    }, error => {
      this.toasterService.error('Erro ao deletar.', '', {
        timeOut: 2000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });
    })

  }

  vizualizarComprovante(element) {
    let codigoPlano = this.form.value.codigoPlano;
    this.planoDeSaudeService.getArquivos(codigoPlano, element.mes).subscribe((resp: Blob) => {
      let blobRg: Blob;
      const fileType = resp.type || 'application/octet-stream';

      let fileName = 'Comprovante_Plano_' + element.data;
      const fileExtension = this.getFileExtensionFromMimeType(fileType);

      if (fileExtension) {
        fileName += '.' + fileExtension;
      }

      blobRg = new Blob([resp], { type: fileType });
      this.downloadFile(blobRg, fileName);
      //blobRg !== null && undefined ? this.flFileRg = true : this.flFileRg = false;
    });
  }

  private getFileExtensionFromMimeType(mimeType: string): string | null {
    const extensionMap = {
      'application/pdf': 'pdf',
      'image/jpeg': 'jpeg',
      'image/jpg': 'jpg',
      'image/png': 'png'
      // Adicione outras extensões e tipos MIME conforme necessário
    };

    return extensionMap[mimeType] || null;
  }

  downloadFile(blob: Blob, fileName: string): void {
    saveAs(blob, fileName);
    this.toasterService.success('Arquivo baixado com sucesso!', '', {
      timeOut: 2000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
    });
  }

}
